var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isDev)?_c('button-link',{staticStyle:{"color":"red","font-weight":"bolder"},attrs:{"to":"/test/test"}},[_vm._v("\n  TEST\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }